import { render, staticRenderFns } from "./ProductsHighlight.vue?vue&type=template&id=5d583123&"
import script from "./ProductsHighlight.vue?vue&type=script&lang=js&"
export * from "./ProductsHighlight.vue?vue&type=script&lang=js&"
import style0 from "./ProductsHighlight.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
